/**
 * PIPEROUTER
 * ----------
 * a) Direct to Reducers
 * b) Pipeline Action Creators
 */


/**
 * DIRECT TO REDUCERS
 */
import { OPEN_NOTE_EDITOR, RESET_ANNOTATION } from 'Reducers/compModels/annotation';
import { SAVE_FILTER_MARKER_COLORS, SAVE_FILTER_PANEL_STATE, SAVE_SORT_ORDER } from 'Reducers/compModels/notebook';
import { SAVE_SELECTEDHIGHLIGHT } from 'Reducers/dataModels/selectedHighlight';


export const resetAnnotation = () => {
  return {
    type: RESET_ANNOTATION
  };
};
export const saveSelectedHighlight = selectedHighlight => {
  return {
    type: SAVE_SELECTEDHIGHLIGHT,
    data: selectedHighlight
  };
};
export const openNoteEditor = () => {
  return {
    type: OPEN_NOTE_EDITOR,
  };
};
export const sortNotebookAnnotations = order => {
  return {
    type: SAVE_SORT_ORDER,
    data: order
  };
};
export const saveDisplayAnnotationColorChange = displayAnnotationColors => {
  return {
    type: SAVE_FILTER_MARKER_COLORS,
    data: displayAnnotationColors
  };
};
export const activateFilterPanel = () => {
  return {
    type: SAVE_FILTER_PANEL_STATE
  };
};


/**
 * Pipeline Action Creators
 */
//INITIALIZATION
export const PIPELINE__INITIALIZE_EREADER = 'PIPELINE--INITIALIZE_EREADER';
export const initializeEreader = createPageObject => {
  return {
    type: PIPELINE__INITIALIZE_EREADER,
    data: {
      cmd: 'CREATE_PAGE_VIEWER',
      data: createPageObject
    }
  };
};

//EXTRACT AND MODIFY URL
export const PIPELINE__EXTRACT_AND_MODIFY_URL = 'PIPELINE--EXTRACT_AND_MODIFY_URL';
export const extractAndModifyUrl = () => {
  return {
    type: PIPELINE__EXTRACT_AND_MODIFY_URL,
    data: {
      cmd: 'EXTRACT_AND_MODIFY_URL'
    }
  };
};

//HIGHLIGHTS
export const PIPELINE__HIGHLIGHT = 'PIPELINE--HIGHLIGHT';
export const createHighlight = ({ markerId, noteText }) => {
  return {
    type: PIPELINE__HIGHLIGHT,
    data: {
      cmd: 'CREATE_HIGHLIGHT',
      data : {
        markerId,
        noteText
      }
    }
  };
};
export const deleteHighlight = (highlightId) => {
  return {
    type: PIPELINE__HIGHLIGHT,
    data: {
      cmd: 'DELETE_HIGHLIGHT',
      data: highlightId
    }
  };
};
export const selectHighlightColor = (markerId, selectedHighlight) => {
  return {
    type: PIPELINE__HIGHLIGHT,
    data: {
      cmd: 'SELECT_HIGHLIGHT',
      data: {
        markerId,
        selectedHighlight
      }
    }
  };
};

//NOTES
export const PIPELINE__NOTE = 'PIPELINE--NOTE';
export const autoSaveNoteText = noteText => {
  return {
    type: PIPELINE__NOTE,
    data: {
      cmd: 'DEBOUNCE_NOTETEXT',
      data: noteText
    }
  };
};
export const createNote = selectedHighlight => {
  return {
    type: PIPELINE__NOTE,
    data: {
      cmd: 'CREATE_NOTETEXT',
      data: selectedHighlight
    }
  };
};
export const deleteNote = selectedHighlight => {
  return {
    type: PIPELINE__NOTE,
    data: {
      cmd: 'DELETE_NOTETEXT',
      data: selectedHighlight
    }
  };
};

//NOTEBOOK
export const PIPELINE__NOTEBOOK = 'PIPELINE--NOTEBOOK';
export const RESET_NOTEBOOK = 'RESET_NOTEBOOK';
export const resetNotebook = () => {
  return {
    type: PIPELINE__NOTEBOOK,
    data: {
      cmd: RESET_NOTEBOOK
    }
  };
};

//NOTIFICATIONS
export const NOTIFICATIONS = 'PIPELINE--NOTIFICATIONS';
export const SET_ISLOADING = 'SET_ISLOADING';
export const SET_PAGE_BREAK_ERROR = 'SET_PAGE_BREAK_ERROR';
export const CREATE_PAGE_VIEWER_FAIL = 'CREATE_PAGE_VIEWER_FAIL';
export const GET_ANNOTATIONS_FAIL = 'GET_ANNOTATIONS_FAIL';
export const GET_PAGE_BREAKS_FAIL = 'GET_PAGE_BREAKS_FAIL';
export const GET_TOC_FAIL = 'GET_TOC_FAIL';
export const GO_TO_PAGE_FAIL = 'GO_TO_PAGE_FAIL';

const notificationsHandler = {
  ['GET_ANNOTATIONS_FAIL']: data => {
    return {
      type: NOTIFICATIONS,
      data: {
        notify: 'GET_ANNOTATIONS_FAIL',
        getAnnotationsFail: true
      }
    };
  },
  ['CREATE_PAGE_VIEWER_FAIL']: data => {
    return {
      type: NOTIFICATIONS,
      data: {
        notify: 'CREATE_PAGE_VIEWER_FAIL',
        createPageViewerFail: true,
        isLoading: false
      }
    };
  },
  ['SET_ISLOADING']: data => {
    return {
      type: NOTIFICATIONS,
      data: {
        notify: SET_ISLOADING,
        isLoading: data
      }
    };
  },
  ['SET_PAGE_BREAK_ERROR']: data => {
    return {
      type: NOTIFICATIONS,
      data: {
        notify: SET_PAGE_BREAK_ERROR,
        message: data.message
      }
    };
  },
  ['GET_PAGE_BREAKS_FAIL']: data => {
    return {
      type: NOTIFICATIONS,
      data: {
        notify: GET_PAGE_BREAKS_FAIL,
        getPageBreaksFail: true
      }
    };
  },
  ['GET_TOC_FAIL']: data => {
    return {
      type: NOTIFICATIONS,
      data: {
        notify: GET_TOC_FAIL,
        getTOCFail: true
      }
    };
  },
  ['GO_TO_PAGE_FAIL']: data => {
    return {
      type: NOTIFICATIONS,
      data: {
        notify: GO_TO_PAGE_FAIL,
        goToPageFail: true
      }
    };
  }
};
export const notifications = (notify, data) => {
  return notificationsHandler[notify](data);
};

//SETTINGS
export const PIPELINE__SETTINGS = 'PIPELINE--SETTINGS';
export const saveMobileSetting = () => {
  return {
    type: PIPELINE__SETTINGS,
    data: {
      cmd: 'INITIALIZE_MOBILE_SETTING'
    }
  };
};

/* TOC */
export const PIPEROUTER__TOC = 'PIPELINE--TOC';

/* NAVIGATION */
export const PIPEROUTER__NAVIGATION = 'PIPELINE--NAVIGATION';
export const goToCfiPage = cfi => {
  return {
    type: PIPEROUTER__NAVIGATION,
    data: {
      cmd: 'GO_TO_CFI_PAGE',
      data: cfi
    }
  };
};

export const goToNextPage = () => {
  return {
    type: PIPEROUTER__NAVIGATION,
    data: {
      cmd: 'GO_TO_NEXT_PAGE'
    }
  };
};

export const goToPreviousPage = () => {
  return {
    type: PIPEROUTER__NAVIGATION,
    data: {
      cmd: 'GO_TO_PREVIOUS_PAGE'
    }
  };
};

export const getNavigationInfo = () => {
  return {
    type: PIPEROUTER__NAVIGATION,
    data: {
      cmd: 'GET_NAVIGATION_INFO'
    }
  };
};

/* PAGE BREAKS */
export const PIPEROUTER__PAGES = 'PIPELINE--PAGES';
export const goToPage = label => {
  return {
    type: PIPEROUTER__PAGES,
    data: {
      cmd: 'GO_TO_PAGE',
      data: label
    }
  };
};
